// Components
import Sidebar from '../../components/Sidebar';
import Form from './DeliveryCarInfo/Form';

function DeliveryCarInfo() {
  return (
    <div className="DeliveryCarInfo">
      <div className="wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="container">
            <div className="page-inner">
              <Form
                name={'ข้อมูลรถผูกสายส่ง'}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeliveryCarInfo;
